import classNames from 'classnames';
import React, { useRef, useState } from 'react';

import DateSelect from './date-select';

// import DateSelect from './DateSelect';

const Content = ({
  title,
  policiesData,
  index,
  setIndex,
}: {
  title: string;
  policiesData: PoliciesData[];
  index: number;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const [language] = useState<'english'>('english');
  const contentRefs = useRef<(HTMLDivElement | null)[]>([]);

  const onMoveToContentElement = (i: number) => {
    const headerOffset = 80;
    const elementPosition = contentRefs.current[i]?.getBoundingClientRect().top;
    const offsetPosition =
      (elementPosition || 0) + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  };

  return (
    <div className="policy-content">
      <div className="policy-title">
        <h1>{title}</h1>
        <span>Last modified: {getDateFormat(policiesData[0].date)}</span>
      </div>
      <div className="policy-index">
        <h2>Index</h2>
        {policiesData[index].article
          .filter((data) => data.index && data[language]?.title)
          .map((data) => (
            <span
              onClick={() => onMoveToContentElement(data.index!)}
              className="list"
            >{`${data[language]?.title}`}</span>
          ))}
      </div>
      {policiesData[index].article.map((data) => (
        <div
          // className={
          //   data[language]
          //     ? data[language]?.noborder
          //       ? 'mb-[15px]'
          //       : 'mb-[39px]'
          //     : ''
          // }
          className={classNames(
            'policy-item',
            {
              'policy-mb-15': data[language]?.noborder,
            },
            { 'policy-mb-40': !data[language]?.noborder },
          )}
          ref={(el) => {
            if (data.index) {
              contentRefs.current[data.index] = el;
            }
          }}
        >
          {data[language]?.title && <h3>{data[language]?.title}</h3>}
          {data[language]?.content && data[language]?.contentInnerhtml ? (
            <div
              dangerouslySetInnerHTML={{ __html: data[language]?.content! }}
            />
          ) : (
            <div>{data[language]?.content}</div>
          )}
          {data[language]?.table && <Table tabledata={data[language]?.table} />}
          {/* {
                    !(data[language]?.noborder) &&
                    <div className="mt-[40px] border border-[1px] border-t-0 border-black" />
                } */}
        </div>
      ))}

      <div className="policy-past">
        <h3>Past Policy</h3>
        <DateSelect
          policiesData={policiesData}
          index={index}
          setIndex={setIndex}
        />
      </div>
    </div>
  );
};

export default Content;

const getDateFormat = (date: string) => {
  const d = new Date(date);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
};

const Table = ({ tabledata }: { tabledata: TableData[][] | undefined }) => {
  if (!tabledata) return <></>;
  return (
    <div className="policy-table">
      <div className="policy-table-header">
        {tabledata[0].map((headerData) => {
          return <div style={headerData.style}>{headerData.content}</div>;
        })}
      </div>
      {tabledata
        .filter((d, i) => i > 0)
        .map((data) => {
          return (
            <div className="policy-table-body">
              {data.map((contentData) => {
                return (
                  <div style={contentData.style}>{contentData.content}</div>
                );
              })}
            </div>
          );
        })}
    </div>
  );
};
